import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { ControlType, SimpleInputModule } from '@hglobal/common';
import { ShopOrder, FormType, DhlOrderForm } from '@pt/models';

@Component({
  selector: 'pt-delivery-dhl',
  templateUrl: './dhl.component.html',
  styleUrls: ['./dhl.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    SimpleInputModule,
  ],
})
export class DhlComponent implements OnInit {
  readonly #formBuilder = inject(FormBuilder);

  order = input.required<ShopOrder>();
  form = input.required<FormType<DhlOrderForm, 'delivery'>>();

  readonly controlTypes = ControlType;

  ngOnInit(): void {
    this.form().removeControl('delivery');
    this.form().addControl(
      'delivery',
      this.#formBuilder.group({
        country: [this.order().location.country, Validators.required],
        postcode: [<any>null, Validators.required],
        regionState: ['', Validators.required],
        city: ['', Validators.required],
        address: ['', Validators.required],
        email: ['', Validators.required],
      }),
    );
  }
}
